module.exports = __webpack_public_path__ + "src/assets/img/strokebrush.359f3e49.png";